import moment from 'moment'
export default async function getNode({ props, state, graphql }) {
  const node = state.get(props.path)

  const result = await graphql.query(`{
    node(id: "${node.id}") {
      groups,
      parent
      fromDate
      toDate
    }
  }`)

  const { groups, parent, fromDate, toDate } = result.node

  let parentGroups = []
  if (parent) {
    const parentNode = await graphql.query(`{
      node(id: "${parent}") {
        groups
      }
    }`)
    parentGroups = parentNode.node.groups
  }

  return {
    groups,
    name: node.name,
    id: node.id,
    parent,
    parentGroups,
    fromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
    toDate: toDate ? moment(toDate).format('YYYY-MM-DD') : null
  }
}



// WEBPACK FOOTER //
// ./src/modules/Node/actions/getNode.js